module.exports = __webpack_public_path__ + "img/Spring_2024_collection.4ba60362.jpg";